import { render, staticRenderFns } from "./AdminBusinessSettingsView.vue?vue&type=template&id=5a5b4094&"
import script from "./AdminBusinessSettingsView.vue?vue&type=script&lang=js&"
export * from "./AdminBusinessSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports